import { SET_LIST_COMPANY, SET_LOADING, SET_DETAIL_COMPANY, SET_LIST_BILLING, SET_DETAIL_BILLING } from './../mutations.type';
import { LIST_STORE_ADMIN, CREATE_COMPANY, DETAIL_COMPANY, UPDATE_COMPANY, LIST_BILLING, UPDATE_PLAN_CUSTOMER, CREATE_PLAN, DETAIL_PLAN, DELETE_PLAN, DETAIL_BILLING } from "../actions.type";
import { SET_ERROR, SET_UPDATED_DATA } from "../mutations.type";
import { AdminCreateCompany, AdminDetailCompany, AdminUpdateCompany, AdminGetListBilling, AdminGetListStore, UpdatePlanCustomer, CreatePlan, DetailPlan, DeletePlan, AdminGetDetailBilling } from '@/services/api/admin.service';
import { ADMIN_ROUTER_NAMES } from "@/router/adminGroup";
import router from "@/router";

const state = {
  loading: false,
  errors: null,
  updatedData: null,
  company: {},
  companies: null,
  billings: [],
  billing: null,
};

const getters = {};

const actions = {
  async [CREATE_COMPANY](
    context: { commit: (arg0: string, arg1: any) => void },
    data: any
  ) {
    try {
      context.commit(SET_LOADING, true);
      await AdminCreateCompany(data.data);
      context.commit(SET_ERROR, null);
      context.commit(SET_LOADING, false);
      router.push(data.redirectPath || { name: ADMIN_ROUTER_NAMES.home });
    } catch (response: any) {
      context.commit(SET_LOADING, false);
      context.commit(SET_ERROR, response);
    }
  },
  async [DETAIL_COMPANY](
    context: { commit: (arg0: string, arg1: any) => void },
    companyId: any
  ) {
    try {
      const { data } = await AdminDetailCompany(companyId);
      context.commit(SET_DETAIL_COMPANY, data);
    } catch (response: any) {
      context.commit(SET_ERROR, response);
    }
  },
  async [UPDATE_COMPANY](
    context: { commit: (arg0: string, arg1: any) => void },
    data: any
  ) {
    try {
      context.commit(SET_LOADING, true);
      await AdminUpdateCompany(data.data);
      context.commit(SET_ERROR, null);
      context.commit(SET_LOADING, false);
      router.push(data.redirectPath || {name: ADMIN_ROUTER_NAMES.home});
    } catch (response: any) {
      context.commit(SET_LOADING, false);
      context.commit(SET_ERROR, response);
    }
  },

  async [LIST_STORE_ADMIN](
    context: { commit: (arg0: string, arg1: any) => void },
    body: any
  ) {
    try {
      context.commit(SET_LOADING, true);
      const res = await AdminGetListStore(body);
      context.commit(SET_LIST_COMPANY, res.data);
      context.commit(SET_LOADING, false);
    } catch (response: any) {
      context.commit(SET_ERROR, response);
      context.commit(SET_LOADING, false);
    }
  },

  async [LIST_BILLING](
    context: { commit: (arg0: string, arg1: any) => void },
    query: any
  ) {
    try {
      const response = await AdminGetListBilling(query);
      context.commit(SET_LIST_BILLING, response.data || []);
      context.commit(SET_ERROR, null);
    } catch (response: any) {
      context.commit(SET_ERROR, response);
    }
  },

  async [DETAIL_BILLING](
    context: { commit: (arg0: string, arg1: any) => void },
    id: number
  ) {
    try {
      const response = await AdminGetDetailBilling(id);
      context.commit(SET_DETAIL_BILLING, response.data || null);
      context.commit(SET_ERROR, null);
    } catch (response: any) {
      context.commit(SET_ERROR, response);
    }
  },

  async [UPDATE_PLAN_CUSTOMER](
    context: { commit: (arg0: string, arg1: any) => void },
    body: any
  ) {
    try {
      context.commit(SET_LOADING, true);
      await UpdatePlanCustomer(body);
      context.commit(SET_LOADING, false);
      context.commit(SET_ERROR, null);
    } catch (response: any) {
      context.commit(SET_LOADING, false);
      context.commit(SET_ERROR, response);
    }
  },
  async [CREATE_PLAN](
    context: { commit: (arg0: string, arg1: any) => void },
    body: any
  ) {
    try {
      context.commit(SET_LOADING, true);
      await CreatePlan(body);
      context.commit(SET_LOADING, false);
      context.commit(SET_UPDATED_DATA, new Date());
      context.commit(SET_ERROR, null);
    } catch (response: any) {
      context.commit(SET_LOADING, false);
      context.commit(SET_ERROR, response);
    }
  },
  async [DETAIL_PLAN](
    context: { commit: (arg0: string, arg1: any) => void },
    query: any
  ) {
    try {
      context.commit(SET_LOADING, true);
      const response = await DetailPlan(query);
      context.commit(SET_LOADING, false);
      context.commit(SET_ERROR, null);
      return response.data;
    } catch (response: any) {
      context.commit(SET_LOADING, false);
      context.commit(SET_ERROR, response);
    }
  },
  async [DELETE_PLAN](
    context: { commit: (arg0: string, arg1: any) => void },
  ) {
    try {
      context.commit(SET_LOADING, true);
      await DeletePlan();
      context.commit(SET_LOADING, false);
      context.commit(SET_UPDATED_DATA, new Date());
      context.commit(SET_ERROR, null);
    } catch (response: any) {
      context.commit(SET_LOADING, false);
      context.commit(SET_ERROR, response);
    }
  },
};

const mutations = {
  [SET_ERROR](state: any, error: any) {
    state.errors = error;
  },
  [SET_LOADING](state: any, loading: boolean) {
    state.loading = loading;
  },
  [SET_UPDATED_DATA](state: any, data: any) {
    state.updatedData = data;
  },
  [SET_DETAIL_COMPANY](state: any, responseData: any) {
    state.company = responseData;
  },
  [SET_LIST_COMPANY](state: any, data: any) {
    state.companies = data;
  },
  [SET_LIST_BILLING](state: any, data: any) {
    state.billings = data;
  },
  [SET_DETAIL_BILLING](state: any, data: any) {
    state.billing = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters,
};
